import { Injectable } from "@angular/core";
import {
  RouteReuseStrategy,
  ActivatedRouteSnapshot,
  DetachedRouteHandle,
} from "@angular/router";

const storedRoutes = new Map<string, DetachedRouteHandle>();
let toBeDeleteUrl: string;
let excludeRoutes: string[] = []; // 不需要缓存的url
@Injectable({
  providedIn: "root",
})
export class KeepAliveService implements RouteReuseStrategy {
  setExcludeRoutes(routes: string[]) {
    excludeRoutes = routes; // 设置不缓存的路由
  }
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    let config = route.routeConfig;
    // console.log("shouldDetach", toBeDeleteUrl, this.getRoutePath(route));
    if (toBeDeleteUrl === this.getRoutePath(route)) {
      // 对于新开的又即将关闭的tab，不缓存
      if (route.children.length === 0) {
        toBeDeleteUrl = "";
      }
      return false;
    }
    if (config && excludeRoutes.includes(this.getRoutePath(route))) {
      return false;
    }
    //Don't store lazy loaded routes
    return config && !config.loadChildren;
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    // console.log("store", this.getRoutePath(route));
    // console.log("store", storedRoutes);
    const key = this.getRoutePath(route);
    storedRoutes.set(key, handle);
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    const key = this.getRoutePath(route);
    return !!route.routeConfig && storedRoutes.has(key);
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
    let config = route.routeConfig;
    const key = this.getRoutePath(route);
    //We don't store lazy loaded routes, so don't even bother trying to retrieve them
    if (!config || config.loadChildren) {
      return false;
    }
    return storedRoutes.get(key) || null;
  }

  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot
  ): boolean {
    // console.log("shouldReuseRoute", future, curr);
    // return future.routeConfig === curr.routeConfig;
    if (future.routeConfig === curr.routeConfig) {
      if (future.children.length === 0 && curr.children.length === 0) {
        // 无子路由时, 通过params和queryParams判断是否复用路由
        return (
          JSON.stringify(future.params) === JSON.stringify(curr.params)
        );
      }
      return true;
    }
    return false;
  }

  getRoutePath(route): string {
    if (route.routeConfig) {
      // const pathParams = JSON.stringify(route.params);
      // const queryParams = new URLSearchParams(route.queryParams).toString();
      const url = route._urlSegment.segments.map((v) => v.path).join("/");
      return "/" + url;
    }
    return "";
  }

  clearCache(path: string) {
    // console.log("clearCache", storedRoutes, path);
    toBeDeleteUrl = path;
    storedRoutes.delete(path);
  }

  clearAllCache() {
    storedRoutes.clear();
  }
}
